var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF780E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30218 6.98707L7.25564 5.03544C7.49409 4.79699 7.81325 4.66309 8.15075 4.66309C8.48825 4.66309 8.80741 4.79515 9.04586 5.03544L11.1497 7.13564C11.3882 7.37409 11.5221 7.69508 11.5221 8.03258C11.5221 8.37192 11.39 8.68924 11.1497 8.92953L9.50625 10.5748C9.88065 11.4472 10.4186 12.2398 11.091 12.9098C11.7642 13.5867 12.5511 14.1204 13.4242 14.4983L15.0677 12.853C15.3061 12.6145 15.6253 12.4806 15.9628 12.4806C16.1292 12.48 16.2942 12.5126 16.4479 12.5766C16.6016 12.6405 16.741 12.7345 16.8579 12.853L18.9636 14.9532C19.202 15.1916 19.3359 15.5126 19.3359 15.8501C19.3359 16.1894 19.2039 16.5068 18.9636 16.7471L17.012 18.6987C16.6048 19.1059 16.0435 19.3388 15.4675 19.3388C15.3483 19.3388 15.2327 19.3297 15.1154 19.3095C12.6868 18.9096 10.2766 17.6165 8.33051 15.6722C6.38621 13.7242 5.09491 11.314 4.69138 8.88367C4.57582 8.194 4.80693 7.48415 5.30218 6.98707ZM5.99185 8.6654C6.34953 10.828 7.51243 12.985 9.26413 14.7367C11.0158 16.4884 13.1711 17.6513 15.3336 18.009C15.6051 18.0549 15.8839 17.9632 16.082 17.7669L17.9988 15.8501L15.9664 13.8159L13.769 16.017L13.7525 16.0335L13.3563 15.8868C12.155 15.4451 11.0641 14.7475 10.1593 13.8423C9.25438 12.9371 8.55715 11.846 8.1159 10.6445L7.96916 10.2483L10.1849 8.03442L8.15258 6.00025L6.2358 7.91703C6.03771 8.11512 5.946 8.39393 5.99185 8.6654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.48c05f7ccaae0bc9f71703464f8d790a.svg";
export { ForwardRef as ReactComponent };